<!-- Nav Menu -->

<template>
  <div id="app">
    <router-view :config="env"/>
  </div>
</template>

<script>
export default {
  data(){
    return{
      env:[]
    }
  },
  mounted(){
    this.env = process.env
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
@media only screen and (max-width:500px) {
  a.navbar-brand {
    padding-left: 3px;
    margin-left: 0px;
    display: contents;
  }
}
.secTwoInfo {
  color: #fff;
  float: right;
  padding-top: 65px;
  padding-right: 55px;
  display: none;
}
</style>
